<template>
  <v-card class="login-container rounded-lg mx-auto">
    <div class="welcome-section">
      <h1>
        Bienvenido <br />
        a <br />
        Digicard Tiempo y Asistencia
      </h1>
    </div>
    <div class="login-section">
      <v-container class="pt-0">
        <v-row align="center" justify="center">
          <v-col class="pa-0">
            <v-avatar class="logo">
              <img src="../../assets/user-avatar.png" alt="logo" />
            </v-avatar>
            <v-card-title class="card-title">Iniciar Sesión</v-card-title>
            <v-alert
              class="mb-2"
              type="error"
              v-if="alertError"
              style="display: flex; justify-content: center; margin: 0 40px"
            >
              {{ alertValidate }}
            </v-alert>
            <v-form ref="form" v-model="valid">
              <v-card-text class="card-actions pa-0">
                <v-text-field
                  outlined
                  :label="$tc('login.user')"
                  prepend-inner-icon="fa-user"
                  color="primary"
                  v-model="email"
                  required
                  dense
                  full-width
                  class="mx-10"
                  :rules="emailRules"
                />
                <v-text-field
                  outlined
                  :label="$tc('login.password')"
                  prepend-inner-icon="fa-lock"
                  v-model="password"
                  color="primary"
                  dense
                  @keyup.enter="signIn()"
                  :type="show ? 'text' : 'password'"
                  :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                  @click:append="show = !show"
                  required
                  full-width
                  class="mt-2 mx-10"
                  :rules="passRules"
                />
                <v-row class="justify-center pt-4">
                  <v-col cols="3" class="ma-0 pa-0">
                    <v-checkbox
                      :label="$tc('login.remember')"
                      color="primary"
                      v-model="remember"
                      class="ma-0 pa-0 pb-8"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="login-actions mx-auto">
                <v-btn
                  rounded
                  outlined
                  block
                  color="primary"
                  @click="isValid"
                  class="my-auto"
                >
                  iniciar sesión
                </v-btn>
              </v-card-actions>
              <p
                class="forgotPass text-center my-auto"
                v-show="showForgotPassword"
              >
                <modal-forgot-pass :email="email" :show="validUser()" />
              </p>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-overlay :opacity="1" v-show="loading">
      <span>
        {{ $tc("dashboard.loading") }}
      </span>
      <v-progress-linear
        buffer-value="0"
        stream
        color="#45D6E5"
      ></v-progress-linear>
    </v-overlay>
  </v-card>
</template>

<script>
import Loader from "../Complement/Loader.vue";
import login from "../../store/login/login";
import insurable from "../../store/common/insurable";
import permissions from "../mixins/permissions";
import modalForgotPass from "./modalForgotPass.vue";

export default {
  mixins: [permissions],
  components: { Loader, modalForgotPass },
  data() {
    return {
      show: false,
      loading: false,
      showLogin: true,
      valid: true,
      emailRules: [
        (v) => !!v || this.$tc("login.userRequired"),
        (v) => (v && v.length > 2) || this.$tc("login.userRules"),
      ],
      passRules: [(v) => !!v || this.$tc("login.passRequired")],
      password: "",
      email: "",
      remember: false,
      user: "",
      alertError: false,
      operId: "",
      userName: "",
      auditRegis: null,
      reloaded: null,
      alertValidate: "",
    };
  },
  mounted() {
    this.email = localStorage.getItem("email");

    if (this.email) {
      this.remember = true;
    }
    let query = localStorage.getItem("operIdLogin");

    if (query) {
      this.loading = true;
      this.showLogin = false;
      this.loginWithOperId(query);
    }
  },
  computed: {
    showForgotPassword() {
      return (
        !process.env.VUE_APP_LOGINBYAD ||
        process.env.VUE_APP_LOGINBYAD === "false"
      );
    },
    pageInit() {
      return insurable.state.initPage;
    },
    insurable() {
      return insurable.state.insurable;
    },
  },
  methods: {
    validUser() {
      return this.email !== "";
    },
    loginWithOperId(query) {
      this.loading = true;
      login.commit("setUser", query);
      login
        .dispatch("userAuthWithOperId")
        .then(async () => {
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.accessError();
        });
    },
    isValid() {
      let valid = this.$refs.form.validate();
      if (this.remember) {
        localStorage.setItem("email", this.email);
      } else {
        localStorage.removeItem("email");
        this.remember = false;
      }
      if (valid) {
        this.signIn();
      } else {
        this.alertError = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.alertError = false;
        }, 2500);
      }
    },
    async signIn() {
      let body = {
        email: this.email.concat("@email.com"),
        password: this.password,
      };
      login.commit("setUser", body);
      if (process.env.VUE_APP_LOGINBYAD === "true") {
        await login
          .dispatch("userAuthAD")
          .then(async () => {
            this.loading = true;
            this.succes();
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
            this.accessError();
          });
      } else {
        await login
          .dispatch("userAuth")
          .then(async () => {
            if (
              localStorage.getItem("active2fa") &&
              localStorage.getItem("active2fa") === "true"
            ) {
              localStorage.setItem("dialogTwoFA", true);
            }
            this.loading = true;
            this.succes();
          })
          .catch((e) => {
            console.log(e);
            this.loading = false;
            this.accessError();
          });
      }
    },
    async succes() {
      await insurable
        .dispatch("getInsurable")
        .then(() => {
          this.reloaded = true;
          this.showLogin = false;
          sessionStorage.setItem("reloaded", this.reloaded);
          let code = this.insurable.map((element) => {
            return element.code;
          });
          localStorage.setItem("asegurables", JSON.stringify(code));
          this.searchIniTPage();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    searchIniTPage() {
      const role = parseInt(localStorage.getItem("init"), 10);
      let page = this.pageInit.find((item) => item.id == role);
      if (this.can(page?.code)) {
        this.$router.push({ path: page.name });
        this.loading = false;
      } else {
        this.$router.push({ path: "Dashboard" });
        this.loading = false;
      }
    },

    accessError() {
      this.showLogin = true;
      this.alertValidate = this.$tc("login.alertError");
      this.$refs.form.resetValidation();
      this.email = "";
      this.password = "";
      this.alertError = true;
      setTimeout(() => {
        this.alertError = false;
      }, 5000);
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: row;
  max-width: 1000px;
  min-height: 500px;
}
.welcome-section {
  flex: 1;
  background-image: url("../../assets/bg-time.jpg");
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 0px;
  text-align: center;
  border-radius: 10px;
  border-bottom-left-radius: 1.5%;
}

.login-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.card-title {
  justify-content: center;
  font-size: 1.5rem;
  color: #0661ad;
  font-weight: bold;
}

.card-actions {
  display: flex;
  flex-direction: column;
}

.login-actions {
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  display: flex;
  margin: 0 auto;
}

.forget {
  color: #0661ad;
}

@media only screen and (max-width: 1000px) {
  .welcome-section {
    display: none;
  }
}
</style>
